// active-session.guard.ts

import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureService } from '../services/feature.service';

@Injectable({
  providedIn: 'root'
})
export class ActiveSessionGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _featureService: FeatureService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      // Check if the guard has already been executed during the current navigation session
      if (this._featureService.getGuardExecuted()) {
        // Guard has already been executed during this navigation session, allow navigation
        return true;
      }

      const res = await this._featureService.checkActiveSession().toPromise();
      console.log("line no. 27", res);

      if (res.data.length === 0) {
        const result = await this._featureService.bookAssessment().toPromise();
        sessionStorage.setItem('deviceId', result.data.session_id);
        console.log("line no. 29", result);

        // Set the flag to indicate that the guard has been executed during this navigation session
        this._featureService.setGuardExecuted();

        return true;
      } else if (res.data.length === 1 && res.data[0].session_id == sessionStorage.getItem('deviceId')) {
        // Set the flag to indicate that the guard has been executed during this navigation session
        this._featureService.setGuardExecuted();

        return true;
      } else {
        this._router.navigate(['/student/dashboard']);
        return false;
      }
    } catch (error) {
      console.error('Error in canActivate:', error);
      // Handle error and navigate to an error page or perform any other necessary action.
      this._router.navigate(['/student/dashboard']);
      return false;
    }
  }
}
